"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const usa_skipnav_1 = __importDefault(require("@uswds/uswds/js/usa-skipnav"));
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const SkipNav = (0, react_1.forwardRef)(({ className, href, ...props }, ref) => {
    const linkRef = (0, react_1.useRef)(null);
    (0, react_1.useImperativeHandle)(ref, () => linkRef.current);
    (0, react_1.useEffect)(() => {
        const linkEl = linkRef.current;
        if (!linkEl)
            return;
        // call USWDS's `on` function to initialize the component
        usa_skipnav_1.default.on(linkEl);
        // on dismount, call USWDS's `off` function to cleanup the component
        return () => {
            usa_skipnav_1.default.off(linkEl);
        };
    }, []);
    function handleClick(e) {
        // prevent router from redirecting - allow uswds js to execute
        e.preventDefault();
    }
    return ((0, jsx_runtime_1.jsx)("a", { className: (0, uswds_react_utils_1.createClassString)('usa-skipnav', className), href: href, ref: linkRef, ...props, onClick: handleClick, children: "Skip to main content" }));
});
exports.default = SkipNav;
